import { Group, Text } from '@mantine/core';
import { useBranding } from '@buildex/theme';

interface TenantLogoProps {
  /** Свёрнутый вариант (узкий сайдбар) */
  collapsed?: boolean;
  height?: number;
}

/**
 * Логотип тенанта. Читает тот же стор брендинга, что и тема (§8) —
 * в preview-режиме меняется мгновенно вместе с цветами.
 */
export function TenantLogo({ collapsed = false, height = 28 }: TenantLogoProps) {
  const branding = useBranding();
  const src = collapsed ? (branding.logoCollapsedUrl ?? branding.logoUrl) : branding.logoUrl;

  if (!src) {
    return (
      <Group gap="xs" wrap="nowrap">
        <Text fw={700} size="lg" c="var(--mantine-color-brand-6)">
          {collapsed ? 'BX' : 'BuildEX'}
        </Text>
      </Group>
    );
  }

  return <img src={src} alt="logo" style={{ height, display: 'block' }} />;
}
